<section class="profit-loss-report">
  <div class="row">
    <div class="col-12">
      <div class="card report-card">
        <div class="card-body">
          <!-- Header with Title and Controls -->
          <div class="row align-items-center mb-3">
            <div class="col-auto">
              <h5 class="card-title m-0">
                <i class="bx bx-chart me-1 text-primary" aria-hidden="true"></i>Profit And Loss Reports
              </h5>
            </div>
            <div class="col">
              <div ngbDropdown autoClose="manual" #dropdown="ngbDropdown">
                <button class="btn btn-outline-secondary" ngbDropdownToggle aria-label="Filter options">
                  <i class="bx bx-filter" aria-hidden="true"></i> Filter
                </button>
                <div ngbDropdownMenu>
                  <div class="p-3">
                    <div class="mb-2">
                      <label for="dateFilter"><i class="bx bx-filter me-1" aria-hidden="true"></i>Date Filter</label>
                      <ng-select id="dateFilter" class="ng-filter" [clearable]="false" [searchable]="false"
                        [(ngModel)]="selectedFilter">
                        <ng-option *ngFor="let f of filters" [value]="f">{{ f }}</ng-option>
                      </ng-select>
                    </div>
                    <ng-container *ngIf="selectedFilter === 'Custom'">
                      <div class="mb-2">
                        <label for="fromDate"><i class="bx bx-calendar me-1" aria-hidden="true"></i>From</label>
                        <input id="fromDate" type="date" [(ngModel)]="fromDate" class="form-control">
                      </div>
                      <div class="mb-2">
                        <label for="toDate"><i class="bx bx-calendar me-1" aria-hidden="true"></i>To</label>
                        <input id="toDate" type="date" [(ngModel)]="toDate" class="form-control">
                      </div>
                    </ng-container>
                    <button (click)="filterAndFetchReport(selectedFilter, dropdown)" class="btn btn-secondary w-100">
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-auto ms-auto">
              <!-- <button ngbTooltip="Print Report" class="btn btn-secondary btn-sm" (click)="printReport()"
                aria-label="Print Report">
                <i class="bx bx-printer" aria-hidden="true"></i>
              </button> -->
              <button ngbTooltip="Download Excel" class="btn btn-secondary btn-sm ms-2" (click)="downloadExcel()"
                aria-label="Download Excel">
                <i class="bx bx-download" aria-hidden="true"></i>
              </button>
            </div>
          </div>

          <!-- Report Content -->
          <div class="report-content">
            <ng-container *ngIf="isLoading; else reportData">
              <div class="text-center py-3">Fetching data, please wait...</div>
            </ng-container>

            <ng-template #reportData>
              <ng-container *ngIf="report && (report.income || report.expenses); else noData">
                <div class="row mb-4">
                   <!-- Expenses Section -->
                  <div class="col-md-6 ps-md-2">
                    <div class="card expenses-card h-100">
                      <div class="card-header bg-light d-flex justify-content-between align-items-center">
                        <h6 class="m-0">Expenses</h6>
                        <span class="text-danger fw-bold">{{ this.totals.expenses | currency:'INR':'symbol':'1.2-2':'en-IN' }}</span>
                      </div>
                      <div class="card-body p-0">
                        <table class="table table-borderless mb-0">
                          <tbody>
                            <tr *ngFor="let entry of report.expenses | keyvalue">
                              <td>{{ entry.key }}</td>
                              <td class="text-end">{{ entry.value | currency:'INR':'symbol':'1.2-2':'en-IN' }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <!-- Revenue Section -->
                  <div class="col-md-6 pe-md-2">
                    <div class="card revenue-card h-100">
                      <div class="card-header bg-light d-flex justify-content-between align-items-center">
                        <h6 class="m-0">Revenue</h6>
                        <span class="text-success fw-bold">{{ this.totals.revenue | currency:'INR':'symbol':'1.2-2':'en-IN' }}</span>
                      </div>
                      <div class="card-body p-0">
                        <table class="table table-borderless mb-0">
                          <tbody>
                            <tr *ngFor="let entry of report.income | keyvalue">
                              <td>{{ entry.key }}</td>
                              <td class="text-end">{{ entry.value | currency:'INR':'symbol':'1.2-2':'en-IN' }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                 
                </div>
                <!-- Net Profit/Loss -->
                <div class="card net-profit-card">
                  <div class="card-body d-flex justify-content-between align-items-center">
                    <h6 class="m-0 fw-bold">Net Profit/Loss</h6>
                    <span [ngClass]="totals.netProfit >= 0 ? 'text-success' : 'text-danger'" class="fw-bold fs-5">
                      {{ this.totals.netProfit | currency:'INR':'symbol':'1.2-2':'en-IN' }}
                    </span>
                  </div>
                </div>
              </ng-container>
              <ng-template #noData>
                <div class="text-center py-3">
                  <ng-container *ngIf="searchKeyword; else noReports">
                    No profit & loss reports found for the search term "{{ searchKeyword }}".
                  </ng-container>
                  <ng-template #noReports>
                    No profit & loss reports found.
                  </ng-template>
                </div>
              </ng-template>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>